"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorThemes = exports.buttonFontSizes = void 0;

var _styles = require("react-components/styles");

var _styledComponents = require("styled-components");

/**
 * Module dependencies.
 */

/**
 * Export `buttonFontSizes`.
 */
var buttonFontSizes = {
  large: (0, _styledComponents.css)(["font-size:17px;font-weight:500;letter-spacing:normal;line-height:24px;"]),
  medium: (0, _styledComponents.css)(["font-size:16px;font-weight:500;letter-spacing:normal;line-height:22px;"]),
  small: (0, _styledComponents.css)(["font-size:16px;font-weight:500;letter-spacing:normal;line-height:22px;"])
};
/**
 * Export `colorThemes`.
 */

exports.buttonFontSizes = buttonFontSizes;
var colorThemes = {
  danger: {
    backgroundColor: (0, _styles.color)('danger100'),
    color: (0, _styles.color)('danger500'),
    disabled: {
      backgroundColor: (0, _styles.color)('danger100'),
      color: (0, _styles.color)('danger200')
    },
    interaction: {
      backgroundColor: (0, _styles.color)('danger200')
    }
  },
  gray: {
    backgroundColor: (0, _styles.color)('gray300'),
    color: (0, _styles.color)('gray900'),
    disabled: {
      backgroundColor: (0, _styles.color)('gray200'),
      color: _styles.color.transparentize('gray900', 0.3)
    },
    interaction: {
      backgroundColor: (0, _styles.color)('gray400')
    }
  },
  primary: {
    backgroundColor: (0, _styles.color)('blue500'),
    color: (0, _styles.color)('white'),
    disabled: {
      backgroundColor: (0, _styles.color)('blue100'),
      color: (0, _styles.color)('blue400')
    },
    interaction: {
      backgroundColor: (0, _styles.color)('blue600')
    }
  },
  secondary: {
    backgroundColor: (0, _styles.color)('blue200'),
    color: (0, _styles.color)('blue500'),
    disabled: {
      backgroundColor: (0, _styles.color)('blue100'),
      color: (0, _styles.color)('blue300')
    },
    interaction: {
      backgroundColor: (0, _styles.color)('blue400')
    }
  },
  success: {
    backgroundColor: (0, _styles.color)('success600'),
    color: (0, _styles.color)('white'),
    disabled: {
      backgroundColor: (0, _styles.color)('success100'),
      color: (0, _styles.color)('white')
    },
    interaction: {
      backgroundColor: (0, _styles.color)('success700')
    }
  }
};
exports.colorThemes = colorThemes;